<p-toast />
<p-confirmDialog />
<div class="px-6 py-4">
  <div class="flex justify-content-between mb-4">
    <p class="text-xl font-semibold">{{ 'layout.configurations.status.title' | translate }}</p>
<ng-container *emPermission="Permission.CONFIG_BSA">
      <p-button
        class="p-button-success"
        icon="pi pi-plus"
        severity="success"
        (onClick)="onAdd()">
    </p-button>
    </ng-container>

  </div>
<p-table
  [value]="statuses"
  [paginator]="true"
  [rows]="10"
  [rowsPerPageOptions]="[10,20,50,100]"
  paginatorPosition="bottom"
  paginatorAlignment="center"
  styleClass="w-full p-datatable-sm">

  <ng-template pTemplate="header">
    <tr>
      <th scope="col" pSortableColumn="status" class="bg-white w-20rem">
        {{ 'layout.configurations.status.labels.statusEn'| translate }}
        <p-sortIcon field="status" />
      </th>
      <th scope="col" pSortableColumn="statusEs" class="bg-white w-20rem">
        {{ 'layout.configurations.status.labels.statusEs'| translate }}
        <p-sortIcon field="statusEs" />
      </th>
      <th scope="col" pSortableColumn="statusAr" class="bg-white w-20rem">
        {{ 'layout.configurations.status.labels.statusAr'| translate }}
        <p-sortIcon field="statusAr" />
      </th>
      <ng-container *emPermission="Permission.CONFIG_BSA">
      <th scope="col" class="bg-white w-10rem pl-3">
        {{ 'layout.configurations.status.actions' | translate }}
      </th></ng-container>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-status>
    <tr>
      <td class="bg-white w-20rem">{{ status.status }}</td>
      <td class="bg-white w-20rem">{{ status.statusEs }}</td>
      <td class="bg-white w-20rem">{{ status.statusAr }}</td>
      <td>
      <ng-container *emPermission="Permission.CONFIG_BSA">
        <p-button   icon="pi pi-pencil"  [outlined]="true"  class="mr-2"
        (onClick)="onEdit(status)"
>
        </p-button></ng-container>
        <p-button icon="pi pi-trash"
                  severity="danger"
                  [outlined]="true"
                  (onClick)="onDelete($event, status.id)">
        </p-button>
      </td>
    </tr>
  </ng-template>

</p-table>
